var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgRedWarning(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 25,
    height: 23.497,
    viewBox: "0 0 25 23.497",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "warning",
    d: "M72.81,86.334,62.285,66.789a1.976,1.976,0,0,0-3.48,0L48.282,86.334a1.976,1.976,0,0,0,1.737,2.913h21.05a1.976,1.976,0,0,0,1.74-2.913Zm-12.264-.113a1.235,1.235,0,1,1,1.235-1.235A1.235,1.235,0,0,1,60.546,86.221ZM61.887,73.8l-.354,7.534a.988.988,0,0,1-1.976,0L59.2,73.8h0a1.342,1.342,0,0,1,1.328-1.4h.013a1.342,1.342,0,0,1,1.342,1.4Z",
    transform: "translate(-48.046 -65.75)",
    fill: "red"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRedWarning);
export default __webpack_public_path__ + "static/media/red-warning.f2165eb2c84b733b2a8f51774584b8ba.svg";
export { ForwardRef as ReactComponent };